import { injectEmspBoCpoApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-cpo.service';

import { baseApi } from '@service/base-api.service';

export const emspBoCpoApi = injectEmspBoCpoApi(baseApi);

export const { useEmspBoGetCposQuery, useEmspBoGetCpoQuery } = emspBoCpoApi;
